import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

type Status = 'not_started' | 'in_progress' | 'finished' | 'invalid_range';

@Pipe({
    standalone: true,
    name: 'dateDiffInPercent',
})
export class DateDiffInPercentPipe implements PipeTransform {
    transform(
        start: Date | string | moment.Moment,
        end: Date | string | moment.Moment
    ): {
        percent: number;
        elapsedDays: number | null;
        remainingDays: number | null;
        status: Status;
    } {
        const msInDay = 1000 * 60 * 60 * 24;
        const s = moment(start);
        const e = moment(end);
        const now = moment();

        if (!s.isValid() || !e.isValid()) {
            return { percent: 0, elapsedDays: null, remainingDays: null, status: 'invalid_range' };
        }

        const totalMs = e.valueOf() - s.valueOf();

        if (totalMs <= 0) {
            if (now.isBefore(s)) {
                const remainingDays = Math.ceil((s.valueOf() - now.valueOf()) / msInDay);
                return { percent: 0, elapsedDays: 0, remainingDays, status: 'not_started' };
            } else {
                return { percent: 100, elapsedDays: 0, remainingDays: 0, status: 'finished' };
            }
        }

        const elapsedMs = now.valueOf() - s.valueOf();
        const rawPercent = (elapsedMs / totalMs) * 100;
        const percent = Math.max(0, Math.min(100, Number.isFinite(rawPercent) ? rawPercent : 0));

        const status: Status = percent <= 0 ? 'not_started' : percent >= 100 ? 'finished' : 'in_progress';

        const clampedElapsedMs = Math.max(0, Math.min(elapsedMs, totalMs));
        const elapsedDays = Math.floor(clampedElapsedMs / msInDay);

        const remainingDays = Math.max(0, e.startOf('day').diff(now.startOf('day'), 'days'));

        return {
            percent,
            elapsedDays,
            remainingDays,
            status,
        };
    }
}
